import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { IOsaExecucaoCustoRecursoModel } from './../../../../../models/osa-execucao-custo-recurso.model';
import { toFormatValue } from './../../../../../shared/util/toFormatValue';
import { OsaExecucaoCustoRecursoService } from './../../../../../services/osa-execucao-custo-recurso.service';
import { BaseFormComponent } from './../../../../../shared/components/base-form/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import Swal from 'sweetalert2';
import { OsaExecucaoAbaCustosRecursosOutrosCustosFormModalComponent } from '../osa-execucao-aba-custos-recursos-outros-custos-form-modal/osa-execucao-aba-custos-recursos-outros-custos-form-modal.component';

@Component({
  selector: 'app-osa-execucao-aba-custos-recursos-outros-custos-list',
  templateUrl: './osa-execucao-aba-custos-recursos-outros-custos-list.component.html',
  styleUrls: ['./osa-execucao-aba-custos-recursos-outros-custos-list.component.scss']
})

export class OsaExecucaoAbaCustosRecursosOutrosCustosListComponent extends BaseFormComponent implements OnInit {
  @Input() secaoId = 1;
  @Output() subtotalChange = new EventEmitter<number>();
  @Input() permiteIncluir: boolean = false;
  @Input() visualizar = false;


  public modelOsaExecucaoCustoRecurso: IOsaExecucaoCustoRecursoModel = {} as IOsaExecucaoCustoRecursoModel;
  public osaExecucaoCustoRecursoDataSource = new MatTableDataSource<IOsaExecucaoCustoRecursoModel>([]);
  public osaExecucaoCustoRecursoSemDados = true;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private osaExecucaoCustoRecursoService: OsaExecucaoCustoRecursoService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {
    this.carregarCustos();
  }

  ngOnChanges(): void {
    const total = this.calcularSubtotal();
    this.subtotalChange.emit(total);
  }

  public async carregarCustos() {
    try {
      this.osaExecucaoCustoRecursoService.obterPorExecucao(this.id, this.secaoId).then((res) => {
        if (res.sucesso) {
          this.osaExecucaoCustoRecursoDataSource = new MatTableDataSource<IOsaExecucaoCustoRecursoModel>
            (
              res.dados
            );
          this.osaExecucaoCustoRecursoDataSource._updateChangeSubscription();
          this.modelOsaExecucaoCustoRecurso = {} as IOsaExecucaoCustoRecursoModel;
          this.osaExecucaoCustoRecursoSemDados = res.dados.length != 0 ? false : true;
        } else {
          this.submit = false;
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          this.router.navigate(['/osaExecucao']);
          return;
        }
      });
    } catch (err) {
      this.submit = false;
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.router.navigate(['/osaExecucao']);
    }
  }

  public async incluir() {
    try {

      const dados = {
        id: 0,
        osaExecucaoId: this.id,
        nome: '',
        valorUnitario: 0,
        quantidade: 0,
        secaoId: this.secaoId
      } as IOsaExecucaoCustoRecursoModel

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = dados;
      const modal = this.matDialog.open(
        OsaExecucaoAbaCustosRecursosOutrosCustosFormModalComponent,
        dialogConfig
      );
      modal.afterClosed().subscribe((data) => {
        this.carregarCustos();
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public async editar(model: IOsaExecucaoCustoRecursoModel) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = model;
      const modal = this.matDialog.open(
        OsaExecucaoAbaCustosRecursosOutrosCustosFormModalComponent,
        dialogConfig
      );
      modal.afterClosed().subscribe((data) => {
        this.carregarCustos();
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  excluir(id: number): void {
    Swal.fire({
      title: 'Confirma a exclusão?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        this.osaExecucaoCustoRecursoService.excluir(id).subscribe(res => {
          if (res.sucesso) {
            this.carregarCustos();
          }
        });
      }
    });
  }

  formatarInput(value) {
    return toFormatValue(value);
  }

  calcularSubtotal(): number {
    const total = this.osaExecucaoCustoRecursoDataSource.data
      ?.reduce((total, item) => total + (item.quantidade * item.valorUnitario || 0), 0) || 0;

    this.subtotalChange.emit(total);

    return total;
  }
}
